import { Component, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { interval } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureSnapshotsService } from '../../../core/services/capture-snapshots.service';
import { CaptureSnapshot } from '../../../core/models/capture-snapshot.model';
import { DownloadService } from 'app/core/services/download.service';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';
import { TitleCasePipe } from '@angular/common';

const snapshotPollingInterval = 3000;

@Component({
    selector: 'app-capture-history-item-type-snapshot-created',
    templateUrl: './capture-history-item-type-snapshot-created.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent, TitleCasePipe]
})
export class CaptureHistoryItemTypeSnapshotCreatedComponent extends CaptureHistoryItemTypeBaseComponent
  implements OnInit, OnChanges, OnDestroy {
  private captureSnapshotsService = inject(CaptureSnapshotsService);
  private downloadService = inject(DownloadService);

  captureSnapshot: CaptureSnapshot;

  snapshotPollingSubscription = null;

  ngOnInit() {
    this.captureSnapshot = this.captureHistoryItem.relatedRecord;
    this.init();
  }

  ngOnChanges() {
    if (this.captureSnapshot) {
      this.init();
    }
  }

  ngOnDestroy() {
    this.stopSnapshotPolling();
  }

  get canDownload() {
    return this.captureSnapshot.fileExpirableDownloadPath;
  }

  onDownloadClick() {
    this.downloadService.getDownloadUrl(this.captureSnapshot.fileExpirableDownloadPath).subscribe(expirableDownload => {
      this.downloadService.download(expirableDownload.url);
    });
  }

  private init() {
    this.stopSnapshotPolling();

    if (this.captureSnapshot.processing) {
      this.startSnapshotPolling(this.captureSnapshot.id);
    }
  }

  private startSnapshotPolling(captureSnapshotId: number) {
    this.snapshotPollingSubscription = interval(snapshotPollingInterval)
      .pipe(mergeMap(() => this.captureSnapshotsService.get(captureSnapshotId)))
      .subscribe(captureSnapshot => {
        this.captureSnapshot = captureSnapshot;

        if (!captureSnapshot.processing) {
          this.stopSnapshotPolling();
        }
      });
  }

  private stopSnapshotPolling() {
    if (this.snapshotPollingSubscription) {
      this.snapshotPollingSubscription.unsubscribe();
    }
  }
}
